// @flow

import TextualRating from './textualRating.styled';

export default TextualRating;
